import { parseNumber } from "../converters/numberInput";

/** Home-size base cost used by the long-distance and packing formulas. */
export const HOME_SIZES: Record<string, number> = {
  Studio: 2000,
  "1 Bedroom": 3000,
  "2 Bedroom": 4500,
  "3 Bedroom": 6500,
  "4+ Bedroom": 9000,
};

/** Typical crew size and hours for a local move, by home size. Rough planning defaults, always editable. */
export const LOCAL_DEFAULTS: Record<string, { crew: number; hours: number }> = {
  Studio: { crew: 2, hours: 3 },
  "1 Bedroom": { crew: 2, hours: 4 },
  "2 Bedroom": { crew: 3, hours: 5 },
  "3 Bedroom": { crew: 3, hours: 7 },
  "4+ Bedroom": { crew: 4, hours: 8 },
};
export const DEFAULT_RATE_PER_MOVER_HOUR = 60;
export const DEFAULT_TRUCK_FEE = 150;

/** Shown as an estimate range: the real quote is more likely to be higher than lower, so the range is lopsided. */
export const RANGE_LOW = 0.8;
export const RANGE_HIGH = 1.35;

/** A non-negative number, or null when empty/unreadable/negative. */
export function readAmount(s: string): number | null {
  const v = parseNumber(s);
  return v !== null && v >= 0 ? v : null;
}

/** Error text for a typed field, or null when it is fine (empty counts as fine = 0). */
export function fieldError(s: string | null, what: string): string | null {
  if (s === null || s.trim() === "") return null;
  return readAmount(s) === null ? `Enter ${what} as a number of 0 or more.` : null;
}

export function localDefault(crew: number, hours: number, rate: number, truckFee: number): number {
  return crew * hours * rate + truckFee;
}

/**
 * Long-distance default. It scales with home size and distance (a heuristic, not a tariff).
 * Real interstate quotes are priced by shipment weight and distance and often exceed this for
 * cross-country moves; we do not have a sourced rate table, so the numbers are left as they were
 * and the UI warns about long hauls instead of inventing figures.
 */
export function longDistanceDefault(base: number, miles: number): number {
  return base * 0.6 + miles * 0.7;
}

export const LONG_HAUL_MILES = 1500;

export function estimateRange(estimated: number, fixed: number): { low: number; high: number } {
  return { low: estimated * RANGE_LOW + fixed, high: estimated * RANGE_HIGH + fixed };
}
